'use client';

import { Button } from '@common/components';
import SvgCalculator from '@common/icon/SvgCalculator';
import { useEffect, useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { SEARCH_PARAMS } from '@/constants';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { YouthSavingsCalculator } from './YouthSavingsCalculator';
interface YouthSavingsCalculatorTriggerProps {
  title: string;
  contentId: string;
}
export const YouthSavingsCalculatorTrigger = ({
  title,
  contentId
}: YouthSavingsCalculatorTriggerProps) => {
  const [opened, setOpened] = useState(() => typeof window !== 'undefined' && new URLSearchParams(window.location.search).get(SEARCH_PARAMS.ENTER_TYPE) === 'share');
  const trackOpen = (source: 'content' | 'share') => {
    trackGtmEvent(GTM_EVENT_TYPE.CLICK_BTN, {
      btn_name: '갈아타기계산기',
      content_name: title,
      content_id: contentId,
      source
    });
  };
  useEffect(() => {
    const enteredViaShare = new URLSearchParams(window.location.search).get(SEARCH_PARAMS.ENTER_TYPE) === 'share';
    if (enteredViaShare) {
      trackOpen('share');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleOpen = () => {
    trackOpen('content');
    setOpened(true);
  };
  return <>
      <button onClick={handleOpen} aria-label="갈아타기 계산기 열기" className="fixed right-20 z-20 flex items-center gap-6 rounded-pill bg-B-500 px-16 py-12 font-700 text-Gray-white shadow-md transition-colors hover:bg-B-600 xl:hidden" style={{
      bottom: 'calc(max(var(--bottom-inset, 0px), 60px) + 92px)'
    }}>
        <SvgCalculator className="size-20" />
        <span className="typo-body4">갈아타기 계산</span>
      </button>
      <div className="hidden xl:block">
        <Button theme="secondary-fill" dimensions="H48" className="w-full" onClick={handleOpen}>
          <SvgCalculator className="size-20" />
          갈아타기 계산기
        </Button>
      </div>
      <ResponsiveDialog opened={opened} onClose={() => setOpened(false)} drawerType="full" isAppBarHeader title="갈아타기 계산기">
        <div className="flex flex-col px-20 pb-32 mobile-tablet:min-h-full mobile-tablet:px-0">
          <YouthSavingsCalculator shareContext={{
          title,
          contentId
        }} />
        </div>
      </ResponsiveDialog>
    </>;
};